// DS: MO3.4.4
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import ThumbStatusIndicators from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicators';
import ShopCardDumb from '../_partials/ShopCardDumb';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import FolderStats from '../../FolderCard/legos/FolderStats';
import PriceWithPoints from '../_partials/PriceWithPoints';
import s from './FolderShopCard.scss';
const FolderShopCard = ({ width , folder , withAuthorDetails , withIndicators =true  })=>{
    const { t  } = useTranslation();
    const { isPaidFolder , isWatchToAccess , pointPrice , formattedDollarPrice  } = normalizePremiumFolderData(folder === null || folder === void 0 ? void 0 : folder.premiumFolderData);
    let indicatorType = null;
    if (isPaidFolder) {
        indicatorType = 'premium-folder';
    } else if (isWatchToAccess) {
        indicatorType = 'watchers-only-folder';
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("a", {
        className: s['link'],
        href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name
        })
    }), /*#__PURE__*/ React.createElement(ShopCardDumb, {
        width: width,
        coverImage: folder.thumb,
        title: folder.name,
        withAuthorDetails: withAuthorDetails,
        author: folder.owner,
        indicatorsSlot: withIndicators && indicatorType ? /*#__PURE__*/ React.createElement(ThumbStatusIndicators, {
            className: s['indicators'],
            indicators: [
                {
                    type: indicatorType,
                    tooltip: t(`thumb.tooltip.${indicatorType}`)
                }
            ]
        }) : undefined,
        belowCoverImageSlot: /*#__PURE__*/ React.createElement(FolderStats, {
            folder: folder
        }),
        detailsRightSlot: /*#__PURE__*/ React.createElement(PriceWithPoints, {
            formattedDollarsPrice: formattedDollarPrice,
            pointsPrice: pointPrice
        })
    }));
};
FolderShopCard.displayName = 'FolderShopCard';
export default FolderShopCard;
